import { difficulty } from '../api/entities';

export const actions = {
  listDifficulty: 'LIST_DIFFICULTY',
};

export function getDifficulties() {
  return difficulty.list(actions.listDifficulty, null, null, true);
}

const INITIAL_STATE = {
  difficulties: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listDifficulty:
      return {
        ...state,
        difficulties: action.body ? action.body._items : state.difficulties,
      };
    default:
      return {
        ...state,
      };
  }
}
